import { MessageBarType } from '@fluentui/react';
import { Log } from '../../../../../../logging/src';
import {
  Account,
  NotificationLabel,
  NotificationSeverity,
  Publisher,
  TythonAdUnit,
  UserContext,
  buildRequestHeadersWithAuthToken,
  constructUrl,
  onNotificationCardAdded,
  onNotificationChanged,
  showErrorToastNotification,
} from '../../../../../@data';
import notificationMessages from '../../../../../NotificationsPanel.Types.messages';
import messages from '../../Manage/ManagePage.messages';
import { ITythonAdUnit } from '../CreateAdunit/types';

export const createTythonAdUnit = async (
  publisher: Publisher,
  userContext: UserContext,
  account: Account,
  adunit: ITythonAdUnit,
  updateLoadingStatus?: (isLoading: boolean) => void
): Promise<TythonAdUnit> => {
  updateLoadingStatus?.(true);
  const adUnit = new TythonAdUnit();
  adUnit.className = 'adunits';

  const body = {
    servingConfig: {
      adUnitName: adunit.name,
      adUnitId: adunit.id,
      accountId: account.id,
      propertyId: adunit.propertyId,
      adTypes: adunit.adTypes,
      nativeProperties: adunit.nativeProperties,
      servingStatus: 'Serving',
      enablebCat: false,
      bCat: [],
      xCat: [],
      enablebAdv: false,
      bAdv: [],
    },
  };

  const requestUrl = constructUrl([publisher, adUnit], undefined, undefined, undefined, 'servingConfig');
  const headers = await buildRequestHeadersWithAuthToken(requestUrl, userContext);

  try {
    const response = await fetch(requestUrl, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: headers,
    });

    if (!response.ok) {
      const resRaw = await response.json();
      showErrorToastNotification({
        text: `Save Ad Unit Failed, ${
          resRaw?.errors?.[0]?.description ?? response.statusText
        }. Please find more details in the notification center.`,
      });
      onNotificationCardAdded({
        // tslint:disable-next-line: no-any
        severity: NotificationSeverity.Error,
        titleMessageDescriptor: notificationMessages.CreateTythonAdUnitFailedTitle,
        content: `Error code: ${resRaw?.errors?.[0]?.code ?? response.status}; Error status: ${
          resRaw?.errors?.[0]?.description ?? response.statusText
        }`,
        notificationLabel: NotificationLabel.CreateTythonAdUnitFailed,
      });
      updateLoadingStatus?.(false);
      Log.error(`create ad unit failed: ${response.status} ${response.statusText}`);
      return Promise.reject();
    }

    const data: TythonAdUnit = await response.json();
    updateLoadingStatus?.(false);
    return Promise.resolve(data);
  } catch (e) {
    updateLoadingStatus?.(false);
    onNotificationChanged({
      messageBarType: MessageBarType.error,
      textMessageDescriptor: messages.createAdunitFailed,
    });
    Log.error(e);
    return Promise.reject();
  }
};
